<div class="flex flex-column align-items-start justify-content-between my-3">
    <div class="flex w-full align-items-center justify-content-between">
        <div>
            <h2 class="m-0 font-semibold text-base mb-2">Dashboard</h2>
            <span class="date">
                {{ today | date:'EEEE' }} &middot; {{ today | date:'dd MMMM yyyy' }}
            </span>
        </div>
        <button pButton class="refreshBtn ml-3" (click)="ngOnInit()">
            <i class="fa fa-refresh" aria-hidden="true"></i>
            <span class="hidden md:inline">Refresh</span>
        </button>
    </div>
</div>

<p-tabs [value]="selectedTab" (valueChange)="onTabChange($event)" [class.tabs--sharing]="selectedTab === 'carSharing'"
    [class.tabs--rental]="selectedTab === 'carRental'">
    <p-tablist>
        @if(carStatistics){
        <p-tab value="carSharing">
            <span class="tab-text" [class.tab-text--sharing-active]="selectedTab === 'carSharing'">Sharing</span>
            <span class="tab-badge" [class.tab-badge--sharing]="selectedTab !== 'carSharing'"
                [class.tab-badge--sharing-active]="selectedTab === 'carSharing'">
                {{ carStatistics.carSharing.totalVehicles ?? 0 }}
            </span>
        </p-tab>
        <p-tab value="carRental">
            <span class="tab-text" [class.tab-text--rental-active]="selectedTab === 'carRental'">Rental</span>
            <span class="tab-badge" [class.tab-badge--rental]="selectedTab !== 'carRental'"
                [class.tab-badge--rental-active]="selectedTab === 'carRental'">
                {{ carStatistics.carRental.totalVehicles ?? 0 }}
            </span>
        </p-tab>
        }
    </p-tablist>
</p-tabs>

<div class="status-rows my-3">
    @for (row of [statusItems.slice(0,8), statusItems.slice(8)]; track $index) {
    <div class="status-section">
        <div class="status-grid">
            @for (item of row; track item.label) {
            <button type="button" class="status-card" [class.cursor-pointer]="!item.noClick" [class.cursor-default]="item.noClick"
                (click)="navigateToVehiclesByStatus(item.statusKey, item.customParams, $event)"
                (keydown.enter)="navigateToVehiclesByStatus(item.statusKey, item.customParams)">
                <div class="flex flex-column md:flex-row align-items-start md:align-items-center gap-1">
                    <div class="status-icon-circle" [style.background]="item.dotColor">
                        <img src="assets/icons/car-fill.svg" alt="" class="status-car-img" />
                    </div>
                    <p class="status-label">{{ item.label }}</p>
                </div>
                <p class="status-count">{{ item.value }}</p>
            </button>
            }
        </div>
    </div>
    }
</div>

<!-- Overview section -->
<div class="overview-section my-3">

    <!-- Header -->
    <div class="overview-header">
        <span class="overview-title">Overview</span>
        <p-select [options]="periodOptions" class="todaySelect" [(ngModel)]="selectedPeriod" size="small"
            (onChange)="onPeriodChange()" />
    </div>

    <!-- Stat cards -->
    <div class="grid mt-3">
        <div class="col-12 lg:col-4">
            <button type="button" class="stat-card w-full text-left"
                (click)="navigateToCustomers(selectedPeriod === 'TODAY', $event)">
                <div class="stat-icon-wrap stat-icon-wrap--blue">
                    <img src="assets/icons/blue-users.svg" class="stat-icon" alt="" />
                </div>
                <div class="stat-content">
                    <p class="stat-label">{{ periodPrefix }} Customers</p>
                    <div class="flex">
                        <p class="stat-number">{{ totalCustomers }}</p>
                        <span class="stat-badge align-items-end">
                            <img src="assets/icons/green-arrow.svg" alt="New"
                                style="width: 13px; height: 13px; margin-right: 3px;" /> New
                        </span>
                    </div>
                </div>
            </button>
        </div>

        <div class="col-12 lg:col-4">
            <button type="button" class="stat-card w-full text-left cursor-pointer"
                (click)="navigateToRides(selectedPeriod === 'TODAY', $event)">
                <div class="stat-icon-wrap stat-icon-wrap--green">
                    <img src="assets/icons/green-car.svg" class="stat-icon" alt="" />
                </div>
                <div class="stat-content">
                    <p class="stat-label">{{ periodPrefix }} Rides</p>
                    <div class="flex">
                        <p class="stat-number">{{ selectedRideStatistics }}</p>
                    </div>
                </div>
            </button>
        </div>

        <div class="col-12 lg:col-4">
            <div class="stat-card">
                <div class="stat-icon-wrap stat-icon-wrap--orange">
                    <img src="assets/icons/orange-wallet.svg" class="stat-icon" alt="" />
                </div>
                <div class="stat-content">
                    <p class="stat-label">{{ periodPrefix }} Collected</p>
                    <div class="flex">
                        <p class="stat-number">
                            <span class="stat-currency">AED</span> {{ selectedRevenueStatistics | number }}
                        </p>
                        <span class="flex align-items-end stat-sub mx-1">card + wallet</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Charts -->
    <div class="grid mt-3">
        <div class="col-12 lg:col-6">
            <div class="chart-card">
                <div class="chart-card-header">
                    <button type="button" class="chart-title text-btn" (click)="navigateToRides(selectedPeriod === 'TODAY', $event)">
                        Rides — {{ selectedPeriodLabel }}
                        <i class="fa-solid fa-arrow-up-right-from-square" style="font-size: 11px; margin-left: 5px; opacity: 0.6;"></i>
                    </button>
                    <button type="button" class="chart-view-all text-btn flex align-items-center" (click)="navigateToRides(selectedPeriod === 'TODAY', $event)">View all
                        <img src="assets/icons/arrow.svg" alt="arrow" />
                    </button>
                </div>
                <div class="chart-wrapper">
                    <p-chart type="bar" [data]="rideChartData" [options]="rideChartOptions"></p-chart>
                </div>
                <div class="chart-peak">
                    <div class="peak-item">
                        <p class="peak-label">{{ peakLabel }}</p>
                        <p class="peak-value">{{ ridesPeakInfo.label }}</p>
                    </div>
                    <div class="peak-item">
                        <p class="peak-label">RIDES IN PEAK</p>
                        <p class="peak-value">{{ ridesPeakInfo.count }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 lg:col-6">
            <div class="chart-card">
                <div class="chart-card-header">
                    <span class="chart-title">Revenue — {{ selectedPeriodLabel }}</span>
                </div>
                <div class="chart-wrapper">
                    <p-chart type="bar" [data]="revenueChartData" [options]="revenueChartOptions"></p-chart>
                </div>
                <div class="chart-peak">
                    <div class="peak-item">
                        <p class="peak-label">{{ peakLabel }}</p>
                        <p class="peak-value">{{ revenuePeakInfo.label }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- <div>
    <app-table-component [data]="activeRides()" [columns]="tableColumns" [totalRecords]="totalRecords()" [rows]="rows" [first]="first" (pageChange)="onPageChange($event)" [tableName]="'Active rides'"
        [searchControl]="searchControl" />
</div> -->
